/* BC Cart Drawer — Mi Calma FR */
(function(){
if(window.__bccInit)return; window.__bccInit=1;
function killNativeDrawer(){
  document.querySelectorAll('#shopify-section-cart-drawer-section, theme-drawer#cart-drawer, cart-drawer-component').forEach(function(n){ n.remove(); });
  document.body.style.marginRight=''; document.body.style.paddingRight='';
  document.documentElement.style.marginRight=''; document.documentElement.style.paddingRight='';
}
if(document.readyState!=='loading'){ killNativeDrawer(); } else { document.addEventListener('DOMContentLoaded', killNativeDrawer); }
setTimeout(killNativeDrawer, 1500);

var CFG=window.BCC_CFG||{};
var UPSELLS=CFG.upsells||[];
var pcache={};
function money(c){return '$'+(c/100).toLocaleString('es-MX',{minimumFractionDigits:2,maximumFractionDigits:2});}
function getP(handle){
  if(pcache[handle])return Promise.resolve(pcache[handle]);
  return fetch('/products/'+handle+'.js').then(r=>r.json()).then(p=>{pcache[handle]=p;return p;});
}
function el(sel){return document.querySelector(sel);}
function open(){ el('.bcc').classList.add('on'); el('.bcc-overlay').classList.add('on'); document.body.style.overflow='hidden'; refresh(); }
function close(){ el('.bcc').classList.remove('on'); el('.bcc-overlay').classList.remove('on'); document.body.style.overflow=''; killNativeDrawer(); }
window.BCCart={open:open, close:close, refresh:refresh};

/* expiry countdown */
var exp=(CFG.expiryMin||10)*60-26;
setInterval(function(){ exp=exp>0?exp-1:(CFG.expiryMin||10)*60;
  var e=el('#bccExp'); if(e)e.textContent=String(Math.floor(exp/60)).padStart(2,'0')+':'+String(exp%60).padStart(2,'0');
},1000);

function lineHTML(it,idx,pdata){
  var imgSrc=it.image;
  if((/pack/i.test(it.handle)||/pack/i.test(it.product_title))&&pdata&&pdata.tags){
    var par0=pcache[(pdata.tags.find(function(t){return t.indexOf('parent:')===0;})||'').slice(7)];
    if(par0&&par0.variants){
      var k0=Object.keys(it.properties||{})[0];
      var c0=k0?(it.properties[k0]||'').split(' / ')[1]:null;
      if(c0){var pinv0=/couleur|color/i.test((par0.options[0]||{}).name||par0.options[0]||'');
        var mv=par0.variants.find(function(vv){return (pinv0?vv.option1:vv.option2)===c0&&vv.featured_image;});
        if(mv)imgSrc=mv.featured_image.src;}
    }
  }
  var img=imgSrc?('<img src="'+imgSrc.replace(/(\.[a-z]+)(\?|$)/,'_160x$1$2')+'">'):'<img>';
  var mid='<div class="bcc-mid"><div class="t">'+it.product_title+'</div>';
  var isPack=/pack/i.test(it.handle)||/pack/i.test(it.product_title);
  if(isPack){
    var props=it.properties||{};
    var parent=pdata&&pdata.tags?(pdata.tags.find(function(t){return t.indexOf('parent:')===0;})||'').slice(7):'';
    var par=parent?pcache[parent]:null;
    if(par&&par.variants&&par.options.length>=2){
      var pinv=/couleur|color/i.test(par.options[0].name||par.options[0]);
      var psz=[],pcl=[];
      par.variants.forEach(function(vv){
        var s=pinv?vv.option2:vv.option1, c=pinv?vv.option1:vv.option2;
        if(s&&psz.indexOf(s)<0)psz.push(s); if(c&&pcl.indexOf(c)<0)pcl.push(c);
      });
      var keys=Object.keys(props);
      mid+='<div class="bcc-packsels">'+keys.map(function(k,pi){
        var cur=(props[k]||'').split(' / ');
        return '<div class="bcc-prow"><span class="pn">'+k+'</span>'
          +'<select class="bcc-p1" data-line="'+idx+'" data-piece="'+pi+'">'+psz.map(function(s){return '<option'+(s===cur[0]?' selected':'')+'>'+s+'</option>';}).join('')+'</select>'
          +'<select class="bcc-p2" data-line="'+idx+'" data-piece="'+pi+'">'+pcl.map(function(c){return '<option'+(c===cur[1]?' selected':'')+'>'+c+'</option>';}).join('')+'</select></div>';
      }).join('')+'</div>';
    } else {
      var pl=Object.keys(props).map(function(k){return k+': '+props[k];}).join('<br>');
      if(pl)mid+='<div class="bcc-props">'+pl+'</div>';
      if(parent&&!par){getP(parent).then(function(){refresh();});}
    }
  } else if(pdata && pdata.options.length>=2){
    var o1=it.options_with_values?null:null;
    var v=pdata.variants.find(function(v){return v.id===it.variant_id;})||{};
    var sizes=[],colors=[];
    pdata.variants.forEach(function(vv){ if(sizes.indexOf(vv.option1)<0)sizes.push(vv.option1); if(colors.indexOf(vv.option2)<0)colors.push(vv.option2); });
    mid+='<div class="bcc-sels">'
      +'<select data-line="'+idx+'" class="bcc-s1">'+sizes.map(function(s){return '<option'+(s===v.option1?' selected':'')+'>'+s+'</option>';}).join('')+'</select>'
      +'<select data-line="'+idx+'" class="bcc-s2">'+colors.map(function(c){return '<option'+(c===v.option2?' selected':'')+'>'+c+'</option>';}).join('')+'</select></div>';
  }
  mid+='<div><span class="bcc-qty"><button data-act="dec" data-line="'+idx+'">−</button><span>'+it.quantity+'</span><button data-act="inc" data-line="'+idx+'">+</button></span>'
     +'<button class="bcc-del" data-act="del" data-line="'+idx+'"><svg viewBox="0 0 24 24" fill="none" stroke-width="1.6"><path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13M10 11v6M14 11v6"/></svg></button></div>';
  if(isPack)mid+='<div class="bcc-tag">🏷 '+it.product_title.replace(/.*—\s*/,'').toUpperCase()+'</div>';
  mid+='</div>';
  var cmp=0;
  if(pdata){ var vv=pdata.variants.find(function(v){return v.id===it.variant_id;}); if(vv&&vv.compare_at_price)cmp=vv.compare_at_price; }
  var right='<div class="bcc-right">';
  if(cmp>it.final_price){ right+='<span class="dto">'+money((cmp-it.final_price)*it.quantity)+' '+(CFG.txtDto||'AHORRO')+'</span>'; }
  right+='<span class="pr">'+money(it.final_line_price)+'</span>';
  if(cmp>it.final_price)right+='<span class="was">'+money(cmp*it.quantity)+'</span>';
  right+='</div>';
  return '<div class="bcc-item">'+img+mid+right+'</div>';
}
function upsellHTML(p,i){
  var v=p.variants[0];
  var sizes=[],colors=[];
  p.variants.forEach(function(vv){ if(sizes.indexOf(vv.option1)<0)sizes.push(vv.option1); if(vv.option2&&colors.indexOf(vv.option2)<0)colors.push(vv.option2); });
  var dto=v.compare_at_price>v.price?Math.round((1-v.price/v.compare_at_price)*100):0;
  return '<div class="bcc-up" data-up="'+i+'" data-handle="'+p.handle+'">'
   +'<a href="/products/'+p.handle+'"><img src="'+(p.featured_image||'')+'"></a>'
   +'<div class="m">'+(dto?'<span class="dto">'+dto+'% '+(CFG.txtDto||'AHORRO')+'</span>':'')
   +'<a class="tl" href="/products/'+p.handle+'"><div class="t">'+p.title+'</div></a>'
   +'<div class="prices">'+(v.compare_at_price>v.price?'<span class="was">'+money(v.compare_at_price)+'</span>':'')+'<span class="now">'+money(v.price)+'</span></div>'
   +'<div class="sels"><select class="up-s1">'+sizes.map(function(s){return '<option>'+s+'</option>';}).join('')+'</select>'
   +(colors.length?'<select class="up-s2">'+colors.map(function(c){return '<option>'+c+'</option>';}).join('')+'</select>':'')+'</div></div>'
   +'<button class="add" data-up="'+i+'">'+(CFG.txtAdd||'Agregar')+'</button></div>';
}
function refresh(){
  fetch('/cart.js').then(r=>r.json()).then(function(cart){
    el('#bccCnt').textContent=cart.item_count;
    var handles=cart.items.map(function(it){return it.handle;});
    Promise.all(handles.map(getP).map(function(p){return p.catch(function(){return null;});})).then(function(pds){
      var html='';
      if(!cart.items.length)html='<div class="bcc-empty">'+(CFG.txtEmpty||'Tu carrito está vacío')+'</div>';
      cart.items.forEach(function(it,i){ html+=lineHTML(it,i+1,pds[i]); });
      // upsells (excluir ya en carrito)
      var inCart=cart.items.map(function(it){return it.handle;});
      var ups=UPSELLS.filter(function(h){return inCart.indexOf(h)<0;});
      Promise.all(ups.map(getP).map(function(p){return p.catch(function(){return null;});})).then(function(upds){
        upds=upds.filter(Boolean);
        if(upds.length){ html+='<div class="bcc-upsh"><svg viewBox="0 0 24 24" fill="none" stroke-width="1.6"><path d="M3 5h2l2.2 11h11L21 8H7"/><circle cx="10" cy="20" r="1.4"/><circle cx="17" cy="20" r="1.4"/></svg>'+(CFG.txtUpsell||'También te podría gustar:')+'</div>';
          upds.forEach(function(p,i){ window['__bccUp'+i]=p; html+=upsellHTML(p,i); });
        }
        html+='<div class="bcc-fit"><span class="ok">✓</span>'+(CFG.txtFit||'')+'</div>';
        el('#bccBody').innerHTML=html;
        // totals + savings
        var savings=0;
        cart.items.forEach(function(it,i){ var pd=pds[i]; if(!pd)return;
          var vv=pd.variants.find(function(v){return v.id===it.variant_id;});
          if(vv&&vv.compare_at_price>vv.price)savings+=(vv.compare_at_price-vv.price)*it.quantity; });
        el('#bccSub').textContent=money(cart.total_price);
        var sv=el('#bccSave'); var svr=el('#bccSaveRow');
        if(savings>0){ sv.style.display=''; sv.textContent=(CFG.txtSave||'Ahorras')+' '+money(savings);
          svr.style.display='flex'; el('#bccSaveAmt').textContent='−'+money(savings);

        } else { sv.style.display='none'; svr.style.display='none'; }
        el('#bccCtaAmt').textContent=money(cart.total_price);
      });
    });
  });
}
/* eventos */
document.addEventListener('click',function(e){
  var t=e.target.closest('[data-act]');
  if(t){ var line=+t.dataset.line;
    fetch('/cart.js').then(r=>r.json()).then(function(cart){
      var it=cart.items[line-1]; if(!it)return;
      var q=t.dataset.act==='inc'?it.quantity+1:(t.dataset.act==='dec'?it.quantity-1:0);
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:line,quantity:q})}).then(refresh);
    }); return; }
  var up=e.target.closest('button.add[data-up]');
  if(up){ var p=window['__bccUp'+up.dataset.up]; var card=up.closest('.bcc-up');
    var s1=card.querySelector('.up-s1'), s2=card.querySelector('.up-s2');
    var v=p.variants.find(function(vv){return vv.option1===s1.value&&(!s2||vv.option2===s2.value);})||p.variants[0];
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:v.id,quantity:1})}).then(refresh); return; }
  if(e.target.closest('#bccClose')||e.target.classList.contains('bcc-overlay')){ close(); return; }
  if(e.target.closest('#bccCta')){ window.location='/checkout'; return; }
  var cartTrigger=e.target.closest('cart-icon,[aria-controls*="cart-drawer"],[on\\:click*="cart-drawer"]');
  if(!cartTrigger){
    var lnk=e.target.closest('a[href]');
    if(lnk){
      try{ var path=new URL(lnk.href, location.origin).pathname;
        if(/^(\/[a-z]{2}(-[a-z]{2})?)?\/cart\/?$/i.test(path)) cartTrigger=lnk;
      }catch(err){}
    }
  }
  if(cartTrigger){ e.preventDefault(); e.stopPropagation(); open(); return; }
},true);
document.addEventListener('change',function(e){
  var us=e.target.closest('.bcc-up .up-s1,.bcc-up .up-s2');
  if(us){
    var card=us.closest('.bcc-up');
    var pd=pcache[card.dataset.handle];
    if(pd){
      var s1=card.querySelector('.up-s1'), s2=card.querySelector('.up-s2');
      var vv=pd.variants.find(function(x){return x.option1===(s1?s1.value:null)&&(!s2||x.option2===s2.value);});
      if(vv&&vv.featured_image&&vv.featured_image.src){
        var im=card.querySelector('img'); if(im)im.src=vv.featured_image.src;
      }
    }
    return;
  }

  var ps=e.target.closest('.bcc-p1,.bcc-p2');
  if(ps){
    var line=+ps.dataset.line;
    var item=document.querySelectorAll('.bcc-item')[line-1];
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      var it=cart.items[line-1]; if(!it)return;
      var keys=Object.keys(it.properties||{});
      var rows=item.querySelectorAll('.bcc-prow');
      var props={};
      rows.forEach(function(row,i){
        props[keys[i]]=row.querySelector('.bcc-p1').value+' / '+row.querySelector('.bcc-p2').value;
      });
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({line:line,quantity:it.quantity,properties:props})}).then(refresh);
    });
    return;
  }
  var s=e.target.closest('.bcc-s1,.bcc-s2'); if(!s)return;
  var line=+s.dataset.line;
  fetch('/cart.js').then(r=>r.json()).then(function(cart){
    var it=cart.items[line-1]; if(!it)return;
    getP(it.handle).then(function(p){
      var wrap=s.closest('.bcc-sels');
      var o1=wrap.querySelector('.bcc-s1').value, o2=wrap.querySelector('.bcc-s2').value;
      var v=p.variants.find(function(vv){return vv.option1===o1&&vv.option2===o2;});
      if(!v){refresh();return;}
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:line,quantity:0})})
        .then(function(){return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:v.id,quantity:it.quantity})});})
        .then(refresh);
    });
  });
});
})();
